class CONSTANTS {
    static template() {
        return `<div class="input__section -price">
			<div class="input__divider">
				<span class="input__divider__label">${acp_woocommerce_i18n.woocommerce.price}</span>
				<div class="input__divider__line"></div>
			</div>
			<div class="input__group">
				<select name="type"  class="select__medium">
					<option value="flat">${CONSTANTS.i18n().REPLACE}</option>
					<option value="increase_percentage">${CONSTANTS.i18n().INCREASE_PERCENTAGE}</option>
					<option value="decrease_percentage">${CONSTANTS.i18n().DECREASE_PERCENTAGE}</option>
					<option value="increase_price">${CONSTANTS.i18n().INCREASE_VALUE}</option>
					<option value="decrease_price">${CONSTANTS.i18n().DECREASE_VALUE}</option>
				</select>
				<div class="input__controlgroup -price">
					<span class="input__control__prepend" data-symbol="">$</span>
					<input type="number" name="value">
				</div>
			</div>
		</div>`;
    }
    static i18n() {
        return {
            REPLACE: acp_woocommerce_i18n.woocommerce.set_new,
            INCREASE_PERCENTAGE: acp_woocommerce_i18n.woocommerce.increase_by + ' %',
            DECREASE_PERCENTAGE: acp_woocommerce_i18n.woocommerce.decrease_by + ' %',
            INCREASE_VALUE: acp_woocommerce_i18n.woocommerce.increase_by + ' value',
            DECREASE_VALUE: acp_woocommerce_i18n.woocommerce.decrease_by + ' value',
        };
    }
}
export default class PriceSection {
    constructor() {
        this.setElement();
        this.attachEvents();
        this.initState();
    }
    setElement() {
        let element = document.createElement('div');
        element.innerHTML = CONSTANTS.template();
        this.el = element.querySelector('.input__section');
    }
    getElement() {
        return this.el;
    }
    getType() {
        return this.getTypeElement().value;
    }
    getTypeElement() {
        return this.getElement().querySelector('[name="type"]');
    }
    getPriceElement() {
        return this.getElement().querySelector('[name="value"]');
    }
    attachEvents() {
        let type = this.getTypeElement();
        type.addEventListener('change', () => { this.initState(); });
    }
    setType(value) {
        this.getElement().querySelector('[name="type"]').value = value;
        this.initState();
    }
    setInputControl(value) {
        this.getElement().querySelectorAll('[data-symbol]').forEach(e => {
            e.innerHTML = value;
        });
    }
    getCurrencySymbol() {
        return woocommerce_admin_meta_boxes && woocommerce_admin_meta_boxes.hasOwnProperty('currency_format_symbol')
            ? woocommerce_admin_meta_boxes.currency_format_symbol
            : '$';
    }
    initState() {
        let type = this.getTypeElement();
        switch (type.value) {
            case 'increase_percentage':
            case 'decrease_percentage':
                this.setInputControl('%');
                this.getPriceElement().setAttribute('step', '0.01');
                break;
            case 'increase_price':
            case 'decrease_price':
                this.setInputControl(this.getCurrencySymbol());
                this.getPriceElement().setAttribute('step', '0.01');
                break;
            default:
                this.setInputControl(this.getCurrencySymbol());
                this.getPriceElement().setAttribute('step', '0.01');
        }
    }
    getValue() {
        return {
            type: this.getTypeElement().value,
            value: this.getPriceElement().value
        };
    }
    show() {
        this.getElement().style.display = 'block';
    }
    hide() {
        this.getElement().style.display = 'none';
    }
}
